import { useCallback, useRef, useState } from "react"
import _ from 'lodash'

export type XpathValueDeterminer = boolean | (() => boolean)
export type XpathsValued = {[xpath: string]: boolean}

export const useXpathsValued2 = () => {
	const xpathValueDeterminers = useRef<{[xpath: string]: XpathValueDeterminer}>({})
	const [xpathsValued, setXpathsValued] = useState<XpathsValued>({})

	const setXpathValuedDeterminer = useCallback((xpath: string, determiner: XpathValueDeterminer) => {
		xpathValueDeterminers.current[xpath] = determiner
	}, [])

	const refreshXpathsValued = useCallback(() => {
		const valued: XpathsValued = {}
		_.forEach(xpathValueDeterminers.current, (determiner, xpath) => {
			if(typeof determiner === 'function' ? determiner() : determiner) {
				valued[xpath] = true
				let parts = xpath.split('.')
				while(parts.length > 2) {
					parts.pop()
					valued[parts.join('.')] = true
				}
			}
		})
		console.debug('[useXpathsValued2] valued xpaths', valued)
		setXpathsValued(valued)
	}, [])

	return {
		setXpathValuedDeterminer,
		refreshXpathsValued,
		xpathsValued,
	}
}
